import { render, staticRenderFns } from "./UpdateConfirm.vue?vue&type=template&id=600c4f07"
import script from "./UpdateConfirm.vue?vue&type=script&lang=ts"
export * from "./UpdateConfirm.vue?vue&type=script&lang=ts"
import style0 from "./UpdateConfirm.vue?vue&type=style&index=0&id=600c4f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports